<ng-container *ngIf="iconPath; else materialIcon">
  <ng-container *ngIf="format === 'svg'; else img">
    <sit-svg [path]="iconPath"  matTooltipPosition="above" matTooltipClass="custom-tooltip" [matTooltip]="tooltip"
    [ngClass]="[sizeClass, colorClass, hoverClass]" [attr.tabIndex]="tabIndex ?? 0"/>
  </ng-container>
  <ng-template #img>
    <img [src]="iconPath" matTooltipPosition="above" matTooltipClass="custom-tooltip" [matTooltip]="tooltip"
      [ngClass]="[sizeClass, colorClass]" [alt]="alt" [attr.tabIndex]="tabIndex ?? 0" role="img" />
  </ng-template>
</ng-container>
<ng-template #materialIcon>
  <mat-icon [ngClass]="sizeClass" [attr.alt]="alt" [attr.tabIndex]="tabIndex ?? 0">{{ icon }}</mat-icon>
  <span class="cdk-visually-hidden" [title]="alt"></span>
</ng-template>